import AppListing from '../app-components/Listing/AppListing';

Vue.component('app-user-office-listing', {
    mixins: [AppListing]
});